const translator = {
    fields: {
        'from_18_to_34': '18 a 34',
        'from_35_to_44': '35 a 44',
        'from_45_to_64': '45 a 64',
        'more_than_64': '> 64',
        'super': 'Super',
        'switch_sub': 'Switch-',
        'switch_plus':'Switch+',
        'v_power': 'V-Power'
    },
    getFieldName: (field) => {
        if(translator.fields.hasOwnProperty(field)){
            return translator.fields[field];
        }
        return field
    }
};

export default translator;


// WEBPACK FOOTER //
// ./src/utils/translations.js